import { render } from "./SettingsMenu.vue?vue&type=template&id=14549b3e"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"

import "./SettingsMenu.vue?vue&type=style&index=0&id=14549b3e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__